import {expandHeight} from "./Animation";
import {PollenCountWidget} from "./PollenCountWidget";
import {IPLocationService} from "../services/location/IPLocationService";
import {RegionService} from "../services/region/RegionService";
import {Region} from "../services/region/Region";
let $ = jQuery;

export class RegionSelector {

    protected regions = $('#pollen-region-selector li');
    protected regionSelectItems = $('.name-of-region , #pollen-region-selector li');
    protected regionsList = $('#pollen-region-selector');

    constructor(private pollenCountWidget: PollenCountWidget,
                private locationService: IPLocationService,
                private regionService: RegionService) {}

    public initialize() {

        this.regions.click(e => this.regionSelected(e));
        this.regionSelectItems.click(() => this.openOrCloseRegionSelector());
        this.setRegionByIp();
    }


    protected setRegion(region: Region) {
        $('.first-ul .name-of-region').html(region.label);
        $('.region-pollen').hide();
        $('#' + region.identifier).show();
    }

    showRegion(region: Region) {
        this.setRegion(region);
        this.pollenCountWidget.openPollenCount();
    }

    setRegionByIp() {
      if(document.cookie.indexOf('userLocation=') === -1) {

        this.locationService.getCurrentLocation().then((location) => {
          this.regionService.getRegionFromLocation(location).then(region => this.setRegion(region));
          let now = new Date();
          now.setTime(now.getTime() + 3600 * 1000);
          document.cookie = ('userLocation=' + JSON.stringify(location) + ';expires=' + now.toUTCString() + ';');
        });
      } else {
        const location =  JSON.parse(this.getCookie('userLocation'));
        //check if the zip code is null. Ipstack occasionally cannot find location data associated with an ip.
        if(location.zip_code === null) {
          let defaultRegion;
          defaultRegion = {label: 'Louisville Region', identifier: 'louisville_region' };
          this.setRegion(defaultRegion);
        }else this.regionService.getRegionFromLocation(location).then(region => this.setRegion(region));
      }
    }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

    /**
     * When a region is selected grab the region and show that region
     * @param e
     */
    regionSelected(e) {
        e.preventDefault();
        const $currentTarget = $(e.currentTarget);
        let textVal = $currentTarget.text();
        let dataVal = $currentTarget.data('value');
        this.showRegion({identifier: dataVal, label: textVal});
    }

    /**
     * Open or close the regions list if the button is pressed
     */
    openOrCloseRegionSelector() {
        if (this.regionsList.is(":visible")) {
            this.regionsList.hide();
        } else {
            this.regionsList.show();
            this.regionsList.height(0);
            expandHeight(this.regionsList, 300)
        }
    }
}


// WEBPACK FOOTER //
// ./assets/ts/src/pollenCount/RegionSelector.ts